import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ThumbnailList } from '../ThumbnailList';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../Accordion';
import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';
import DownloadButton from './buttons/DowloadBotton';
import QRCodeButton from './buttons/QrButton';
import DicomSender from './buttons/DicomSend';
import UploadDocuments from '../UploadDocument';
import { useLocation } from 'react-router-dom';
import { useViewportGrid } from '@ohif/ui-next';

const StudyItem = ({
  date,
  description,
  numInstances,
  modalities,
  isActive,
  onClick,
  isExpanded,
  displaySets,
  activeDisplaySetInstanceUIDs,
  onClickThumbnail,
  onDoubleClickThumbnail,
  onClickUntrack,
  viewPreset = 'thumbnails',
  ThumbnailMenuItems,
  StudyMenuItems,
  StudyInstanceUID,
  onRefresh,
}: withAppTypes) => {
  const [vistaUsuario, setVistaUsuario] = useState('');
  const [rolUsuario, setRolUsuario] = useState('');
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    const localStr = localStorage.getItem('usuario');
    const session = localStr ? JSON.parse(localStr) : null;
    const tiposVista = session ? session.user.vistas : [];
    const tiposRol = session ? session.user.role : '';
    setRolUsuario(tiposRol);
    setVistaUsuario(tiposVista);
  }, []);

  const location = useLocation();
  const isTemporalView = location.pathname.includes('temporalView');
  const seriesColumn = {
    description: 'Descripcion',
    seriesNumber: 'Series',
    modality: '',
    instances: 'Imagenes',
  };

  const handleRefresh = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onRefresh && !isRefreshing) {
      setIsRefreshing(true);
      try {
        window.location.reload(true);
        // await onRefresh(StudyInstanceUID);
      } finally {
        setTimeout(() => setIsRefreshing(false), 1000); // Delay para evitar múltiples clicks
      }
    }
  };

  const [hasAutoSelected, setHasAutoSelected] = useState(false);
  const [{ activeViewportId }] = useViewportGrid();

  useEffect(() => {
    // Si el estudio está activo, tiene displaySets y no tiene displaySets activos
    if (
      isActive &&
      displaySets &&
      displaySets.length > 0 &&
      (!activeDisplaySetInstanceUIDs || activeDisplaySetInstanceUIDs.length === 0) &&
      !hasAutoSelected &&
      activeViewportId
    ) {
      setHasAutoSelected(true);
      // Auto-seleccionar el primero con un retardo para permitir a OHIF cargar los hooks
      setTimeout(() => {
        if (onDoubleClickThumbnail) {
          try {
            onDoubleClickThumbnail(displaySets[0].displaySetInstanceUID);
          } catch (e) {
            console.warn('Auto-select error caught:', e);
          }
        }
      }, 800);
    }
  }, [isActive, displaySets, activeDisplaySetInstanceUIDs, hasAutoSelected, onDoubleClickThumbnail]);

  return (
    <Accordion
      type="single"
      collapsible
      onClick={onClick}
      onKeyDown={() => { }}
      role="button"
      tabIndex={0}
      defaultValue={isActive ? 'study-item' : undefined}
    >
      <AccordionItem value="study-item">
        <AccordionTrigger className={classnames('hover:bg-accent bg-popover group w-full rounded')}>
          <div className="flex h-[40px] w-full flex-row overflow-hidden">
            <div className="flex w-full flex-row items-center">
              <div className="flex min-w-0 flex-col items-start text-[13px]">
                {/* <Tooltip>
                  <TooltipContent>{date}</TooltipContent>
                  <TooltipTrigger
                    className="w-full"
                    asChild
                  >
                    <div className="h-[18px] w-full max-w-[120px] overflow-hidden truncate whitespace-nowrap text-left text-white">
                      {date}
                    </div>
                  </TooltipTrigger>
                </Tooltip> */}
                {/* <Tooltip>
                  <TooltipContent>{description}</TooltipContent>
                  <TooltipTrigger
                    className="w-full"
                    asChild
                  >
                    <div className="text-muted-foreground h-[18px] w-full overflow-hidden truncate whitespace-nowrap text-left">
                      {description}
                    </div>
                  </TooltipTrigger>
                </Tooltip> */}
              </div>
              <div className="flex flex-row justify-between">
                <div className="text-muted-foreground flex flex-col items-start  text-[9px] sm:text-[12px]">
                  <div className="max-w-[150px] overflow-hidden text-ellipsis">{modalities}</div>
                  <div>{date}</div>
                </div>
                {onRefresh && (
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <button
                        onClick={handleRefresh}
                        disabled={isRefreshing}
                        className={classnames(
                          'flex h-8 w-8 items-center justify-center rounded-md transition-all',
                          'hover:bg-accent text-muted-foreground hover:text-white',
                          isRefreshing && 'animate-spin opacity-50 cursor-not-allowed'
                        )}
                        aria-label="Refrescar imágenes"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                          />
                          <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                        </svg>
                      </button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Refrescar imágenes del estudio</p>
                    </TooltipContent>
                  </Tooltip>
                )}
              </div>
              {StudyMenuItems && (
                <div className="ml-2 flex items-center">
                  <StudyMenuItems StudyInstanceUID={StudyInstanceUID} />
                </div>
              )}
            </div>
          </div>
        </AccordionTrigger>
        <AccordionContent
          onClick={event => {
            event.stopPropagation();
          }}
        >
          <div className="flex flex-col gap-1 px-4 py-2">
            {(vistaUsuario.includes('DOC') || rolUsuario === 'admin') && (
              <UploadDocuments
                seriesColumn={seriesColumn}
                value={''}
                temporalView={isTemporalView}
                seriesStudy={[]}
                instanceUid={String(StudyInstanceUID) || ''}
              />
            )}

            {!isTemporalView && (vistaUsuario.includes('SEND DICOM') || rolUsuario === 'admin') && (
              <div className="hidden">
                <QRCodeButton instanceUid={String(StudyInstanceUID) || ''} />
                <DicomSender studyMetadata={String(StudyInstanceUID) || ''}></DicomSender>
              </div>
            )}
          </div>

          {isExpanded && displaySets && (
            <ThumbnailList
              thumbnails={displaySets}
              activeDisplaySetInstanceUIDs={activeDisplaySetInstanceUIDs}
              onThumbnailClick={onClickThumbnail}
              onThumbnailDoubleClick={onDoubleClickThumbnail}
              onClickUntrack={onClickUntrack}
              viewPreset={viewPreset}
              ThumbnailMenuItems={ThumbnailMenuItems}
            />
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

StudyItem.propTypes = {
  date: PropTypes.string.isRequired,
  description: PropTypes.string,
  modalities: PropTypes.string.isRequired,
  numInstances: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool,
  displaySets: PropTypes.array,
  activeDisplaySetInstanceUIDs: PropTypes.array,
  onClickThumbnail: PropTypes.func,
  onDoubleClickThumbnail: PropTypes.func,
  onClickUntrack: PropTypes.func,
  viewPreset: PropTypes.string,
  StudyMenuItems: PropTypes.func,
  StudyInstanceUID: PropTypes.string,
  onRefresh: PropTypes.func,
};

export { StudyItem };
